import { Box } from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';

export type AskTone = 'coral' | 'lime';

// PROPOSED. The one control that always means the conversation, floating at
// the foot of the page above whatever is under it. With nothing going on it
// starts one ("Ask me something"); with one minimised it goes back to it. The
// same place and the same button either way, so it reads as one thing in two
// states rather than two controls.
//
// Absolutely placed, so whatever holds it needs `position: 'relative'`.
const FloatingAsk = ({
  label,
  tone = 'coral',
  onPress,
}: {
  label: string;
  tone?: AskTone;
  onPress: () => void;
}) => (
  <Box
    sx={{
      position: 'absolute',
      left: 24,
      right: 24,
      bottom: 16,
      zIndex: 2,
      // Lime is a try-out, not a style yet: no lime button exists, so it is set
      // here until one is picked. Coral is the theme's own opt-in class.
      ...(tone === 'lime' && {
        '& .MuiButton-root': {
          bgcolor: 'custom.limeGreen.500',
          color: 'text.primary',
          '&:hover': { bgcolor: 'custom.limeGreen.600' },
        },
      }),
    }}
  >
    <Button
      variant='primary'
      size='lg'
      isFullWidth
      className={tone === 'coral' ? 'coral' : undefined}
      ariaLabel={label}
      onPress={onPress}
    >
      {label}
    </Button>
  </Box>
);

export default FloatingAsk;
